// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/account/v1/account_service.proto (package protos.vision.account.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { GetMyVisionPreferencesRequestSchema, GetMyVisionPreferencesResponseSchema } from "./get_my_vision_preferences_pb";
import { file_vision_account_v1_get_my_vision_preferences } from "./get_my_vision_preferences_pb";
import type { UpdateMyVisionPreferencesRequestSchema, UpdateMyVisionPreferencesResponseSchema } from "./update_my_vision_preferences_pb";
import { file_vision_account_v1_update_my_vision_preferences } from "./update_my_vision_preferences_pb";

/**
 * Describes the file vision/account/v1/account_service.proto.
 */
export const file_vision_account_v1_account_service: GenFile = /*@__PURE__*/
  fileDesc("Cid2aXNpb24vYWNjb3VudC92MS9hY2NvdW50X3NlcnZpY2UucHJvdG8SGHByb3Rvcy52aXNpb24uYWNjb3VudC52MTK4AgoNVmlzaW9uQWNjb3VudBKNAQoWR2V0TXlWaXNpb25QcmVmZXJlbmNlcxI3LnByb3Rvcy52aXNpb24uYWNjb3VudC52MS5HZXRNeVZpc2lvblByZWZlcmVuY2VzUmVxdWVzdBo4LnByb3Rvcy52aXNpb24uYWNjb3VudC52MS5HZXRNeVZpc2lvblByZWZlcmVuY2VzUmVzcG9uc2UiABKWAQoZVXBkYXRlTXlWaXNpb25QcmVmZXJlbmNlcxI6LnByb3Rvcy52aXNpb24uYWNjb3VudC52MS5VcGRhdGVNeVZpc2lvblByZWZlcmVuY2VzUmVxdWVzdBo7LnByb3Rvcy52aXNpb24uYWNjb3VudC52MS5VcGRhdGVNeVZpc2lvblByZWZlcmVuY2VzUmVzcG9uc2UiAGIGcHJvdG8z", [file_vision_account_v1_get_my_vision_preferences, file_vision_account_v1_update_my_vision_preferences]);

/**
 * Per-account Vision settings. The account is taken from the authenticated Firebase
 * token, never from a request field.
 *
 * @generated from service protos.vision.account.v1.VisionAccount
 */
export const VisionAccount: GenService<{
  /**
   * @generated from rpc protos.vision.account.v1.VisionAccount.GetMyVisionPreferences
   */
  getMyVisionPreferences: {
    methodKind: "unary";
    input: typeof GetMyVisionPreferencesRequestSchema;
    output: typeof GetMyVisionPreferencesResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.account.v1.VisionAccount.UpdateMyVisionPreferences
   */
  updateMyVisionPreferences: {
    methodKind: "unary";
    input: typeof UpdateMyVisionPreferencesRequestSchema;
    output: typeof UpdateMyVisionPreferencesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_vision_account_v1_account_service, 0);

